import Vue from 'vue';
import Vuex from 'vuex';
import { pt, es } from './lang';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    lang: 'pt',
    translations: { pt, es },
    resellers: null,
    supervisor: null,
  },
  mutations: {
    setLanguage(state, lang) {
      state.lang = lang;
    },
    setResellers(state, response) {
      state.resellers = response;
    },
    setSupervisor(state, response) {
      state.supervisor = response;
    },
  },
  actions: {
    setLanguage({ commit }, lang) {
      commit('setLanguage', lang);
    },
    setResellers({ commit }, params) {
      commit('setResellers', params);
    },
    setSupervisor({ commit }, params) {
      commit('setSupervisor', params);
    },
  },
  getters: {
    translate: state => state.translations[state.lang] || state.translations.pt,
    resellers: state => state.resellers || [],
    supervisor: state => state.supervisor,
  },
});

export default store;
